import autosize from 'autosize'
import '../vendor/jquery.custom-select'

let form = {
    classNameErrors: 'form-errors',
    classNameField: 'form-field',
    classNameInput: 'form-input',
    classNameIsBusy: 'is-busy',
    classNameIsError: 'is-error',
    classNameIsFocus: 'is-focus',
    classNameIsSuccess: 'is-success',

    init() {
        this.initAjax()
        this.initConfirm()
        this.initInputs()
    },

    initAjax() {
        $.ajaxSetup({
            headers: {'X-CSRF-TOKEN': $('#csrf-token').attr('content')}
        })

        $(document).on('submit', 'form[data-ajax]', this.onAjaxFormSubmit.bind(this))
    },

    initConfirm() {
        $('input[data-confirm]').on('click', (e) => {
            if ($(this).prop('checked')) {
                if (!confirm($(this).attr('data-confirm'))) {
                    e.preventDefault()
                }
            }
        });
    },

    initInputs() {
        $('select').customSelect()

        $('textarea')
            .each((i, el) => autosize(el))
            .on('blur focus', (e) => {
                $(this).closest(`.${this.classNameInput}`).toggleClass(this.classNameIsFocus)
            })
    },

    onAjaxFormSubmit(e) {
        let $form
        let data
        let xhr

        e.preventDefault()

        $form = $(e.target)
        data = {}

        // Update UI
        $form.addClass(this.classNameIsBusy);
        $form.removeClass(this.classNameIsSuccess);
        $(`.${this.classNameFormField}`, $form).removeClass(this.classNameIsError);
        $(`.${this.classNameErrors}`, $form).remove();
        $(`.${this.classNameFormError}`, $form).remove();

        $.each($form.serializeArray(), (i, field) => {
            data[field.name] = field.value
        })

        xhr = $.ajax({
            cache: false,
            data: $form.serialize(),
            dataType: 'json',
            method: $form.attr('method').toUpperCase(),
            url: $form.attr('action')
        })

        $.when(xhr).then(
            (response, status) => {
                $form.removeClass(this.classNameIsBusy)
                $form.trigger('ajaxForm:complete')

                if (status === 'success') {
                    $form.addClass(this.classNameIsSucces)
                    $form.trigger('ajaxForm:success', [response])

                    if (response.next) {
                        window.location.href = response.next
                    }
                } else {
                    $form.trigger('ajaxForm:error', [response])
                }
            },
            (xhr) => {
                $form.removeClass(this.classNameIsBusy);
                $form.trigger('ajaxForm:complete');

                if (xhr.status === 422) {
                    $form.trigger('ajaxForm:validationError', [xhr.responseJSON])
                    this.processErrors(xhr.responseJSON, $form)
                } else {
                    // window.location.href = '/error/' + xhr.status;
                }

                $form.trigger('ajaxForm:error', [xhr.responseJSON]);
            }
        )

        // Trigger events
        $form.trigger('ajaxForm:send', [data]);
    },

    processErrors(fields, $form) {
        let $field
        let $input
        let $errors
        let errors
        let name

        $errors = $(`<ul class="${this.classNameErrors}"></ul>`)

        for(let field in fields) {
            errors = fields[field]

            // Output errors to console
            errors.forEach((error) => {
                console.warn(error)
            })

            // Convert object notation to array notation
            name = field.split('.')
            name = name.join('[') + Array(name.length).join(']')
            $input = $(`[name='${name}']`, $form)
            $field = $input.closest(`.${this.classNameField}`)

            if (!$input.length) {
                // Attempt array notation
                $input = $(`[name='${name}[]']`, $form).first()

                if (!$input.length) {
                    continue
                }
            }

            $errors.append($('<li/>').text(errors[0]))
            $field.addClass(this.classNameIsError)
        }

        $form.append($errors)
    }
}

export default form